import { Crew } from './_models'

export const toSignOnDateKey = (value?: string | null): string => {
  const raw = String(value || '').trim()
  if (!raw) return ''

  const matched = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!matched) return ''

  const year = Number(matched[1])
  const month = Number(matched[2])
  const day = Number(matched[3])
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return ''
  if (month < 1 || month > 12 || day < 1 || day > 31) return ''

  return `${matched[1]}-${matched[2]}-${matched[3]}`
}

export const toSignOnMonthKey = (value?: string | null): string => {
  const dateKey = toSignOnDateKey(value)
  if (dateKey) return dateKey.slice(0, 7)

  const raw = String(value || '').trim()
  if (!raw) return ''
  const matched = raw.match(/^(\d{4})-(\d{2})/)
  if (!matched) return ''
  const month = Number(matched[2])
  if (!Number.isFinite(month) || month < 1 || month > 12) return ''
  return `${matched[1]}-${matched[2]}`
}

export const buildCrewSignOnDateMap = (crewMembers: Crew[]): Map<number, string> => {
  const map = new Map<number, string>()
  crewMembers.forEach((crew) => {
    const crewId = Number(crew.id)
    if (!Number.isFinite(crewId) || crewId <= 0) return

    const signOnDate = toSignOnDateKey((crew as any).latestSignOnDate)
    if (signOnDate) {
      map.set(crewId, signOnDate)
    }
  })
  return map
}

export const getCrewSignOnDate = (
  crewId: number | null | undefined,
  signOnDateByCrewId: Map<number, string>
): string => {
  const id = Number(crewId || 0)
  if (!Number.isFinite(id) || id <= 0) return ''
  return signOnDateByCrewId.get(id) || ''
}

export const getCrewSignOnMonth = (
  crewId: number | null | undefined,
  signOnDateByCrewId: Map<number, string>
): string => {
  const signOnDate = getCrewSignOnDate(crewId, signOnDateByCrewId)
  return signOnDate ? signOnDate.slice(0, 7) : ''
}

export const isMonthBeforeSignOn = (monthValue?: string | null, signOnMonth?: string | null): boolean => {
  const month = toSignOnMonthKey(monthValue)
  const minMonth = toSignOnMonthKey(signOnMonth)
  if (!month || !minMonth) return false
  return month < minMonth
}

export const isDateBeforeSignOn = (dateValue?: string | null, signOnDate?: string | null): boolean => {
  const date = toSignOnDateKey(dateValue)
  const minDate = toSignOnDateKey(signOnDate)
  if (!date || !minDate) return false
  return date < minDate
}

export const getEarliestSignOnMonth = (crewMembers: Crew[]): string => {
  const months = crewMembers
    .map((crew) => toSignOnMonthKey((crew as any).latestSignOnDate))
    .filter((value) => !!value)
    .sort()

  return months[0] || ''
}
